export const schoolTagMaster: Array<{ value: string; label: string }> = [
    { value: '1', label: '駅チカ' },
    { value: '2', label: '初心者OK' },
    { value: '3', label: '未就学児ＯＫ' },
    { value: '4', label: '手ぶらＯＫ' },
    { value: '5', label: '異年齢混合' },
    { value: '6', label: '送迎付き' },
];
